var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Account verification | MyWhoosh - Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-8 mx-auto login-box"
  }, [_c('div', {
    staticClass: "text-center validation"
  }, [_vm.verified === 'success' ? _c('img', {
    staticClass: "icon",
    attrs: {
      "src": "assets/images/icon_check.svg",
      "alt": ""
    }
  }) : _vm._e(), _vm.verified === 'failed' ? _c('img', {
    staticClass: "icon",
    attrs: {
      "src": "assets/images/icon_warning.svg",
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "mt-5"
  }, [_vm._v(" " + _vm._s(_vm.text) + " "), _vm.verified === 'failed' ? _c('div', [_c('button', {
    staticClass: "btn-universal mt-5",
    attrs: {
      "role": "button",
      "href": ""
    },
    on: {
      "click": _vm.resendHandler
    }
  }, [_vm._v("Resend")])]) : _vm._e(), _vm.verified === 'success' ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#000",
      "font-size": "21px"
    }
  }, [_vm._v("Thank you!")]), _vm._v(" "), _c('br'), _c('br'), _c('router-link', {
    staticClass: "btn-universal mt-5",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("ENJOY YOUR RIDE")])], 1) : _vm._e(), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verified === 'pending',
      expression: "verified === 'pending'"
    }],
    staticClass: "validation_dots"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }